module.exports = __webpack_public_path__ + "media/aerial-farm-hd02.154871bd.mp4";